<!-- Start::Off-canvas sidebar-->
<div
  #sidebar
  class="offcanvas sidebar offcanvas-end header-sidebar-offcanvas"
  tabindex="-1"
  id="header-sidebar"
  aria-labelledby="sidebarLabel"
>
  <div class="offcanvas-header rounded-0">
    <h5 class="fs-14 text-uppercase mb-0 fw-semibold" id="sidebarLabel">
      Notifications
    </h5>
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
      (click)="onClose()"
    ></button>
  </div>
  <div class="offcanvas-body rounded-0 p-0">
    <ul
      ngbNav
      #nav="ngbNav"
      class="nav nav-tabs tab-style-1 d-block"
      role="tablist"
    >
      <ng-container ngbNavItem>
        <li class="nav-item" role="presentation">
          <a ngbNavLink class="nav-link"
            ><i class="fe fe-message-circle fs-15 me-2"></i>Chat</a
          >
        </li>
        <ng-template ngbNavContent>
          <div
            class="tab-pane border-start-0 border-end-0 rounded-0 p-0"
            id="chat"
            role="tabpanel"
          >
            <div class="list d-flex align-items-center border-bottom border-top p-3">
              <div class="">
                <span class="avatar bg-primary rounded-circle avatar-md"
                  >CH</span
                >
              </div>
              <a class="wrapper w-100 ms-3" href="javascript:void(0);">
                <p class="mb-0 d-flex">
                  <b>New Websites is Created</b>
                </p>
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center">
                    <i class="fa-regular fa-clock text-muted me-1 fs-11"></i>
                    <small class="text-muted ms-auto">30 mins ago</small>
                    <p class="mb-0"></p>
                  </div>
                </div>
              </a>
            </div>
            <div class="list d-flex align-items-center border-bottom p-3">
              <div class="">
                <span class="avatar bg-danger rounded-circle avatar-md">N</span>
              </div>
              <a class="wrapper w-100 ms-3" href="javascript:void(0);">
                <p class="mb-0 d-flex">
                  <b>Prepare For the Next Project</b>
                </p>
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center">
                    <i class="fa-regular fa-clock text-muted me-1 fs-11"></i>
                    <small class="text-muted ms-auto">2 hours ago</small>
                    <p class="mb-0"></p>
                  </div>
                </div>
              </a>
            </div>
            <div class="list d-flex align-items-center border-bottom p-3">
              <div class="">
                <span class="avatar bg-info rounded-circle avatar-md">S</span>
              </div>
              <a class="wrapper w-100 ms-3" href="javascript:void(0);">
                <p class="mb-0 d-flex">
                  <b>Decide the live Discussion</b>
                </p>
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center">
                    <i class="fa-regular fa-clock text-muted me-1 fs-11"></i>
                    <small class="text-muted ms-auto">3 hours ago</small>
                    <p class="mb-0"></p>
                  </div>
                </div>
              </a>
            </div>
            <div class="list d-flex align-items-center border-bottom p-3">
              <div class="">
                <span class="avatar bg-warning rounded-circle avatar-md"
                  >K</span
                >
              </div>
              <a class="wrapper w-100 ms-3" href="javascript:void(0);">
                <p class="mb-0 d-flex">
                  <b>Meeting at 3:00 pm</b>
                </p>
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center">
                    <i class="fa-regular fa-clock text-muted me-1 fs-11"></i>
                    <small class="text-muted ms-auto">4 hours ago</small>
                    <p class="mb-0"></p>
                  </div>
                </div>
              </a>
            </div>
            <div class="list d-flex align-items-center border-bottom p-3">
              <div class="">
                <span class="avatar bg-success rounded-circle avatar-md"
                  >R</span
                >
              </div>
              <a class="wrapper w-100 ms-3" href="javascript:void(0);">
                <p class="mb-0 d-flex">
                  <b>Prepare for Presentation</b>
                </p>
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center">
                    <i class="fa-regular fa-clock text-muted me-1 fs-11"></i>
                    <small class="text-muted ms-auto">1 day ago</small>
                    <p class="mb-0"></p>
                  </div>
                </div>
              </a>
            </div>
            <div class="list d-flex align-items-center border-bottom p-3">
              <div class="">
                <span class="avatar bg-pink rounded-circle avatar-md">MS</span>
              </div>
              <a class="wrapper w-100 ms-3" href="javascript:void(0);">
                <p class="mb-0 d-flex">
                  <b>Prepare for Presentation</b>
                </p>
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center">
                    <i class="fa-regular fa-clock text-muted me-1 fs-11"></i>
                    <small class="text-muted ms-auto">1 day ago</small>
                    <p class="mb-0"></p>
                  </div>
                </div>
              </a>
            </div>
            <div class="list d-flex align-items-center border-bottom p-3">
              <div class="">
                <span class="avatar bg-purple rounded-circle avatar-md">L</span>
              </div>
              <a class="wrapper w-100 ms-3" href="javascript:void(0);">
                <p class="mb-0 d-flex">
                  <b>Prepare for Presentation</b>
                </p>
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center">
                    <i class="fa-regular fa-clock text-muted me-1 fs-11"></i>
                    <small class="text-muted ms-auto">45 minutes ago</small>
                    <p class="mb-0"></p>
                  </div>
                </div>
              </a>
            </div>
            <div class="list d-flex align-items-center border-bottom p-3">
              <div class="">
                <span class="avatar bg-blue rounded-circle avatar-md">U</span>
              </div>
              <a class="wrapper w-100 ms-3" href="javascript:void(0);">
                <p class="mb-0 d-flex">
                  <b>Prepare for Presentation</b>
                </p>
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center">
                    <i class="fa-regular fa-clock text-muted me-1 fs-11"></i>
                    <small class="text-muted ms-auto">2 days ago</small>
                    <p class="mb-0"></p>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </ng-template>
      </ng-container>
      <ng-container ngbNavItem>
        <li class="nav-item" role="presentation">
          <a ngbNavLink class="nav-link"
            ><i class="fe fe-bell fs-15 me-2"></i>Notifications</a
          >
        </li>
        <ng-template ngbNavContent>
          <div
            class="tab-pane border-start-0 border-end-0 rounded-0 p-0"
            id="notifications"
            role="tabpanel"
          >
            <div class="list-group list-group-flush">
              <div class="list-group-item d-flex align-items-center border-top">
                <span
                  class="avatar avatar-lg online avatar-rounded flex-shrink-0"
                >
                  <img src="./assets/images/faces/1.jpg" alt="img" />
                </span>
                <div class="ms-3">
                  <strong>Madeleine</strong> Hey! there I' am available....
                  <div class="small text-muted">3 hours ago</div>
                </div>
              </div>
              <div class="list-group-item d-flex align-items-center">
                <span
                  class="avatar avatar-lg online avatar-rounded flex-shrink-0"
                >
                  <img src="./assets/images/faces/2.jpg" alt="img" />
                </span>
                <div class="ms-3">
                  <strong>Anthony</strong> New product Launching...
                  <div class="small text-muted">5 hour ago</div>
                </div>
              </div>
              <div class="list-group-item d-flex align-items-center">
                <span class="avatar avatar-lg avatar-rounded flex-shrink-0">
                  <img src="./assets/images/faces/3.jpg" alt="img" />
                </span>
                <div class="ms-3">
                  <strong>Olivia</strong> New Schedule Realease......
                  <div class="small text-muted">45 minutes ago</div>
                </div>
              </div>
              <div class="list-group-item d-flex align-items-center">
                <span class="avatar avatar-lg avatar-rounded flex-shrink-0">
                  <img src="./assets/images/faces/4.jpg" alt="img" />
                </span>
                <div class="ms-3">
                  <strong>Madeleine</strong> Hey! there I' am available....
                  <div class="small text-muted">3 hours ago</div>
                </div>
              </div>
              <div class="list-group-item d-flex align-items-center">
                <span class="avatar avatar-lg avatar-rounded flex-shrink-0">
                  <img src="./assets/images/faces/5.jpg" alt="img" />
                </span>
                <div class="ms-3">
                  <strong>Anthony</strong> New product Launching...
                  <div class="small text-muted">5 hour ago</div>
                </div>
              </div>
              <div class="list-group-item d-flex align-items-center">
                <span class="avatar avatar-lg avatar-rounded flex-shrink-0">
                  <img src="./assets/images/faces/6.jpg" alt="img" />
                </span>
                <div class="ms-3">
                  <strong>Olivia</strong> New Schedule Realease......
                  <div class="small text-muted">45 minutes ago</div>
                </div>
              </div>
              <div class="list-group-item d-flex align-items-center border-bottom">
                <span class="avatar avatar-lg avatar-rounded flex-shrink-0">
                  <img src="./assets/images/faces/7.jpg" alt="img" />
                </span>
                <div class="ms-3">
                  <strong>Olivia</strong> Hey! there I' am available....
                  <div class="small text-muted">12 minutes ago</div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-container>
      <ng-container ngbNavItem>
        <li class="nav-item mb-0" role="presentation">
          <a
            ngbNavLink
            class="nav-link "
            data-bs-toggle="tab"
            data-bs-target="#friends"
            aria-selected="true"
            role="tab"
            ><i class="fe fe-users fs-15 me-2"></i>Friends</a
          >
        </li>
        <ng-template ngbNavContent>
          <div
            class="tab-pane border-start-0 border-end-0 rounded-0 p-0 active show"
            id="friends"
            role="tabpanel"
          >
            <div class="list-group list-group-flush">
              <div class="list-group-item d-flex align-items-center border-top">
                <span
                  class="avatar avatar-md online avatar-rounded flex-shrink-0"
                >
                  <img src="./assets/images/faces/1.jpg" alt="img" />
                </span>
                <div class="ms-2">
                  <div
                    class="fw-semibold"
                    data-bs-toggle="modal"
                    (click)="ChatModal(chatmodel)"
                  >
                    Mozelle Belt
                  </div>
                </div>
                <div class="ms-auto">
                  <a
                    href="javascript:void(0);"
                    class="btn btn-sm btn-light"
                    data-bs-toggle="modal"
                    (click)="ChatModal(chatmodel)"
                    ><i class="fab fa-facebook-messenger"></i
                  ></a>
                </div>
              </div>
              <div class="list-group-item d-flex align-items-center">
                <span class="avatar avatar-md avatar-rounded flex-shrink-0">
                  <img src="./assets/images/faces/2.jpg" alt="img" />
                </span>
                <div class="ms-2">
                  <div
                    class="fw-semibold"
                    data-bs-toggle="modal"
                    (click)="ChatModal(chatmodel)"
                  >
                    Florinda Carasco
                  </div>
                </div>
                <div class="ms-auto">
                  <a
                    href="javascript:void(0);"
                    class="btn btn-sm btn-light"
                    data-bs-toggle="modal"
                    (click)="ChatModal(chatmodel)"
                    ><i class="fab fa-facebook-messenger"></i
                  ></a>
                </div>
              </div>
              <div class="list-group-item d-flex align-items-center">
                <span class="avatar avatar-md avatar-rounded flex-shrink-0">
                  <img src="./assets/images/faces/5.jpg" alt="img" />
                </span>
                <div class="ms-2">
                  <div
                    class="fw-semibold"
                    data-bs-toggle="modal"
                    (click)="ChatModal(chatmodel)"
                  >
                    Alina Bernier
                  </div>
                </div>
                <div class="ms-auto">
                  <a
                    href="javascript:void(0);"
                    class="btn btn-sm btn-light"
                    data-bs-toggle="modal"
                    (click)="ChatModal(chatmodel)"
                    ><i class="fab fa-facebook-messenger"></i
                  ></a>
                </div>
              </div>
              <div class="list-group-item d-flex align-items-center">
                <span
                  class="avatar avatar-md online avatar-rounded flex-shrink-0"
                >
                  <img src="./assets/images/faces/6.jpg" alt="img" />
                </span>
                <div class="ms-2">
                  <div
                    class="fw-semibold"
                    data-bs-toggle="modal"
                    (click)="ChatModal(chatmodel)"
                  >
                    Zula Mclaughin
                  </div>
                </div>
                <div class="ms-auto">
                  <a
                    href="javascript:void(0);"
                    class="btn btn-sm btn-light"
                    data-bs-toggle="modal"
                    (click)="ChatModal(chatmodel)"
                    ><i class="fab fa-facebook-messenger"></i
                  ></a>
                </div>
              </div>
              <div class="list-group-item d-flex align-items-center">
                <span
                  class="avatar avatar-md online avatar-rounded flex-shrink-0"
                >
                  <img src="./assets/images/faces/8.jpg" alt="img" />
                </span>
                <div class="ms-2">
                  <div
                    class="fw-semibold"
                    data-bs-toggle="modal"
                    (click)="ChatModal(chatmodel)"
                  >
                    Isidro Heide
                  </div>
                </div>
                <div class="ms-auto">
                  <a
                    href="javascript:void(0);"
                    class="btn btn-sm btn-light"
                    data-bs-toggle="modal"
                    (click)="ChatModal(chatmodel)"
                    ><i class="fab fa-facebook-messenger"></i
                  ></a>
                </div>
              </div>
              <div class="list-group-item d-flex align-items-center">
                <span
                  class="avatar avatar-md online avatar-rounded flex-shrink-0"
                >
                  <img src="./assets/images/faces/8.jpg" alt="img" />
                </span>
                <div class="ms-2">
                  <div
                    class="fw-semibold"
                    data-bs-toggle="modal"
                    (click)="ChatModal(chatmodel)"
                  >
                    Mozelle Belt
                  </div>
                </div>
                <div class="ms-auto">
                  <a href="javascript:void(0);" class="btn btn-sm btn-light"
                    ><i class="fab fa-facebook-messenger"></i
                  ></a>
                </div>
              </div>
              <div class="list-group-item d-flex align-items-center">
                <span
                  class="avatar avatar-md online avatar-rounded flex-shrink-0"
                >
                  <img src="./assets/images/faces/9.jpg" alt="img" />
                </span>
                <div class="ms-2">
                  <div
                    class="fw-semibold"
                    data-bs-toggle="modal"
                    (click)="ChatModal(chatmodel)"
                  >
                    Florinda Carasco
                  </div>
                </div>
                <div class="ms-auto">
                  <a
                    href="javascript:void(0);"
                    class="btn btn-sm btn-light"
                    data-bs-toggle="modal"
                    (click)="ChatModal(chatmodel)"
                    ><i class="fab fa-facebook-messenger"></i
                  ></a>
                </div>
              </div>
              <div class="list-group-item d-flex align-items-center">
                <span
                  class="avatar avatar-md online avatar-rounded flex-shrink-0"
                >
                  <img src="./assets/images/faces/10.jpg" alt="img" />
                </span>
                <div class="ms-2">
                  <div
                    class="fw-semibold"
                    data-bs-toggle="modal"
                    (click)="ChatModal(chatmodel)"
                  >
                    Alina Bernier
                  </div>
                </div>
                <div class="ms-auto">
                  <a href="javascript:void(0);" class="btn btn-sm btn-light"
                    ><i class="fab fa-facebook-messenger"></i
                  ></a>
                </div>
              </div>
              <div class="list-group-item d-flex align-items-center">
                <span class="avatar avatar-md avatar-rounded flex-shrink-0">
                  <img src="./assets/images/faces/11.jpg" alt="img" />
                </span>
                <div class="ms-2">
                  <div
                    class="fw-semibold"
                    data-bs-toggle="modal"
                    (click)="ChatModal(chatmodel)"
                  >
                    Zula Mclaughin
                  </div>
                </div>
                <div class="ms-auto">
                  <a
                    href="javascript:void(0);"
                    class="btn btn-sm btn-light"
                    data-bs-toggle="modal"
                    (click)="ChatModal(chatmodel)"
                    ><i class="fab fa-facebook-messenger"></i
                  ></a>
                </div>
              </div>
              <div class="list-group-item d-flex align-items-center">
                <span
                  class="avatar avatar-md online avatar-rounded flex-shrink-0"
                >
                  <img src="./assets/images/faces/12.jpg" alt="img" />
                </span>
                <div class="ms-2">
                  <div
                    class="fw-semibold"
                    data-bs-toggle="modal"
                    (click)="ChatModal(chatmodel)"
                  >
                    Isidro Heide
                  </div>
                </div>
                <div class="ms-auto">
                  <a href="javascript:void(0);" class="btn btn-sm btn-light"
                    ><i class="fab fa-facebook-messenger"></i
                  ></a>
                </div>
              </div>
              <div class="list-group-item d-flex align-items-center">
                <span
                  class="avatar avatar-md online avatar-rounded flex-shrink-0"
                >
                  <img src="./assets/images/faces/2.jpg" alt="img" />
                </span>
                <div class="ms-2">
                  <div
                    class="fw-semibold"
                    data-bs-toggle="modal"
                    (click)="ChatModal(chatmodel)"
                  >
                    Florinda Carasco
                  </div>
                </div>
                <div class="ms-auto">
                  <a
                    href="javascript:void(0);"
                    class="btn btn-sm btn-light"
                    data-bs-toggle="modal"
                    (click)="ChatModal(chatmodel)"
                    ><i class="fab fa-facebook-messenger"></i
                  ></a>
                </div>
              </div>
              <div class="list-group-item d-flex align-items-center">
                <span
                  class="avatar avatar-md online avatar-rounded flex-shrink-0"
                >
                  <img src="./assets/images/faces/2.jpg" alt="img" />
                </span>
                <div class="ms-2">
                  <div
                    class="fw-semibold"
                    data-bs-toggle="modal"
                    (click)="ChatModal(chatmodel)"
                  >
                    Alina Bernier
                  </div>
                </div>
                <div class="ms-auto">
                  <a
                    href="javascript:void(0);"
                    class="btn btn-sm btn-light"
                    data-bs-toggle="modal"
                    (click)="ChatModal(chatmodel)"
                    ><i class="fab fa-facebook-messenger"></i
                  ></a>
                </div>
              </div>
              <div class="list-group-item d-flex align-items-center">
                <span
                  class="avatar avatar-md online avatar-rounded flex-shrink-0"
                >
                  <img src="./assets/images/faces/3.jpg" alt="img" />
                </span>
                <div class="ms-2">
                  <div
                    class="fw-semibold"
                    data-bs-toggle="modal"
                    (click)="ChatModal(chatmodel)"
                  >
                    Zula Mclaughin
                  </div>
                </div>
                <div class="ms-auto">
                  <a
                    href="javascript:void(0);"
                    class="btn btn-sm btn-light"
                    data-bs-toggle="modal"
                    (click)="ChatModal(chatmodel)"
                    ><i class="fab fa-facebook-messenger"></i
                  ></a>
                </div>
              </div>
              <div class="list-group-item d-flex align-items-center">
                <span
                  class="avatar avatar-md online avatar-rounded flex-shrink-0"
                >
                  <img src="./assets/images/faces/4.jpg" alt="img" />
                </span>
                <div class="ms-2">
                  <div
                    class="fw-semibold"
                    data-bs-toggle="modal"
                    (click)="ChatModal(chatmodel)"
                  >
                    Isidro Heide
                  </div>
                </div>
                <div class="ms-auto">
                  <a
                    href="javascript:void(0);"
                    class="btn btn-sm btn-light"
                    data-bs-toggle="modal"
                    (click)="ChatModal(chatmodel)"
                    ><i class="fab fa-facebook-messenger"></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </ul>
    <div class="tab-content show">
      <div [ngbNavOutlet]="nav"></div>
    </div>
    <!-- Message Modal -->

    <ng-template #chatmodel let-modal>
      <div
        class="chatmodalopen "
        id="chatmodel"  
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-right chat chatbox m-0" role="document">
          <div class="modal-content chat border-0">
            <div class="card overflow-hidden mb-0 border-0 shadow-none">
              <!-- action-header -->
              <div class="action-header clearfix">
                <div class="float-start hidden-xs d-flex">
                  <div class="avatar avatar-lg rounded-circle me-3">
                    <img
                      src="./assets/images/faces/6.jpg"
                      class="rounded-circle user_img"
                      alt="img"
                    />
                  </div>
                  <div class="align-items-center mt-2">
                    <h5 class="text-fixed-white mb-0">Daneil Scott</h5>
                    <span class="dot-label bg-success"></span
                    ><span class="me-3 text-fixed-white">online</span>
                  </div>
                </div>
                <ul class="ah-actions actions align-items-center float-end">
                  <li class="call-icon">
                    <a
                      class="d-done d-md-block phone-button"
                      data-bs-toggle="modal"
                      data-bs-target="#audiomodal"
                      (click)="
                        audioModal(audiomodal); modal.dismiss('Cross click')
                      "
                      data-bs-target="#audiomodal"
                    >
                      <i class="fe fe-phone"></i>
                    </a>
                  </li>
                  <li class="video-icon">
                    <a
                      class="d-done d-md-block phone-button"
                      data-bs-toggle="modal"
                      (click)="
                        audioModal(videomodal); modal.dismiss('Cross click')
                      "
                      data-bs-target="#videomodal"
                    >
                      <i class="fe fe-video"></i>
                    </a>
                  </li>
                  <li ngbDropdown class="dropdown">
                    <a
                      ngbDropdownToggle
                      data-bs-toggle="dropdown"
                      aria-expanded="true"
                    >
                      <i class="fe fe-more-vertical"></i>
                    </a>
                    <ul ngbDropdownMenu class="dropdown-menu dropdown-menu-end">
                      <li ngbDropdownItem class="dropdown-item">
                        <i class="fa fa-user-circle"></i> View profile
                      </li>
                      <li ngbDropdownItem class="dropdown-item">
                        <i class="fa fa-users"></i>Add friends
                      </li>
                      <li ngbDropdownItem class="dropdown-item">
                        <i class="fa fa-plus"></i> Add to group
                      </li>
                      <li ngbDropdownItem class="dropdown-item">
                        <i class="fa fa-ban"></i> Block
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a
                      class=""
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      (click)="modal.dismiss('Cross click')"
                    >
                      <i class="fe fe-x-circle text-fixed-white"></i>
                    </a>
                  </li>
                </ul>
              </div>
              <!-- action-header end -->

              <!-- msg_card_body -->
              <div class="card-body msg_card_body">
                <div class="chat-box-single-line">
                  <abbr class="timestamp">February 1st, 2019</abbr>
                </div>
                <div class="d-flex justify-content-start">
                  <div class="img_cont_msg">
                    <img
                      src="./assets/images/faces/6.jpg"
                      class="rounded-circle user_img_msg"
                      alt="img"
                    />
                  </div>
                  <div class="msg_cotainer">
                    Hi, how are you Jenna Side?
                    <span class="msg_time">8:40 AM, Today</span>
                  </div>
                </div>
                <div class="d-flex justify-content-end">
                  <div class="msg_cotainer_send">
                    Hi Connor Paige i am good tnx how about you?
                    <span class="msg_time_send">8:55 AM, Today</span>
                  </div>
                  <div class="img_cont_msg">
                    <img
                      src="./assets/images/faces/9.jpg"
                      class="rounded-circle user_img_msg"
                      alt="img"
                    />
                  </div>
                </div>
                <div class="d-flex justify-content-start">
                  <div class="img_cont_msg">
                    <img
                      src="./assets/images/faces/6.jpg"
                      class="rounded-circle user_img_msg"
                      alt="img"
                    />
                  </div>
                  <div class="msg_cotainer">
                    I am good too, thank you for your chat template
                    <span class="msg_time">9:00 AM, Today</span>
                  </div>
                </div>
                <div class="d-flex justify-content-end">
                  <div class="msg_cotainer_send">
                    You welcome Connor Paige
                    <span class="msg_time_send">9:05 AM, Today</span>
                  </div>
                  <div class="img_cont_msg">
                    <img
                      src="./assets/images/faces/9.jpg"
                      class="rounded-circle user_img_msg"
                      alt="img"
                    />
                  </div>
                </div>
                <div class="d-flex justify-content-start">
                  <div class="img_cont_msg">
                    <img
                      src="./assets/images/faces/6.jpg"
                      class="rounded-circle user_img_msg"
                      alt="img"
                    />
                  </div>
                  <div class="msg_cotainer">
                    Yo, Can you update Views?
                    <span class="msg_time">9:07 AM, Today</span>
                  </div>
                </div>
                <div class="d-flex justify-content-end mb-4">
                  <div class="msg_cotainer_send">
                    But I must explain to you how all this mistaken born and I
                    will give
                    <span class="msg_time_send">9:10 AM, Today</span>
                  </div>
                  <div class="img_cont_msg">
                    <img
                      src="./assets/images/faces/9.jpg"
                      class="rounded-circle user_img_msg"
                      alt="img"
                    />
                  </div>
                </div>
                <div class="d-flex justify-content-start">
                  <div class="img_cont_msg">
                    <img
                      src="./assets/images/faces/6.jpg"
                      class="rounded-circle user_img_msg"
                      alt="img"
                    />
                  </div>
                  <div class="msg_cotainer">
                    Yo, Can you update Views?
                    <span class="msg_time">9:07 AM, Today</span>
                  </div>
                </div>
                <div class="d-flex justify-content-end mb-4">
                  <div class="msg_cotainer_send">
                    But I must explain to you how all this mistaken born and I
                    will give
                    <span class="msg_time_send">9:10 AM, Today</span>
                  </div>
                  <div class="img_cont_msg">
                    <img
                      src="./assets/images/faces/9.jpg"
                      class="rounded-circle user_img_msg"
                      alt="img"
                    />
                  </div>
                </div>
                <div class="d-flex justify-content-start">
                  <div class="img_cont_msg">
                    <img
                      src="./assets/images/faces/6.jpg"
                      class="rounded-circle user_img_msg"
                      alt="img"
                    />
                  </div>
                  <div class="msg_cotainer">
                    Yo, Can you update Views?
                    <span class="msg_time">9:07 AM, Today</span>
                  </div>
                </div>
                <div class="d-flex justify-content-end mb-4">
                  <div class="msg_cotainer_send">
                    But I must explain to you how all this mistaken born and I
                    will give
                    <span class="msg_time_send">9:10 AM, Today</span>
                  </div>
                  <div class="img_cont_msg">
                    <img
                      src="./assets/images/faces/9.jpg"
                      class="rounded-circle user_img_msg"
                      alt="img"
                    />
                  </div>
                </div>
                <div class="d-flex justify-content-start">
                  <div class="img_cont_msg">
                    <img
                      src="./assets/images/faces/6.jpg"
                      class="rounded-circle user_img_msg"
                      alt="img"
                    />
                  </div>
                  <div class="msg_cotainer">
                    Okay Bye, text you later..
                    <span class="msg_time">9:12 AM, Today</span>
                  </div>
                </div>
              </div>
              <!-- msg_card_body end -->
              <!-- card-footer -->
              <div class="card-footer border-top">
                <div class="msb-reply d-flex">
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Typing...."
                    />
                    <button type="button" class="btn btn-primary">
                      <i class="far fa-paper-plane" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
              <!-- card-footer end -->
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <!--End modal -->

    <!--Video Modal -->
    <ng-template #videomodal let-modal>
      <div id="videomodal" class="">
        <div class="modal-dialog m-0" role="document">
          <div class="modal-content bg-fixed-dark border-0">
            <div class="modal-body mx-auto text-center p-5">
              <h5 class="text-fixed-white">Valex Video call</h5>
              <img
                src="./assets/images/faces/6.jpg"
                class="rounded-circle user-img-circle h-8 w-8 mt-4 mb-3"
                alt="img"
              />
              <h4 class="mb-1 fw-semibold text-fixed-white">Daneil Scott</h4>
              <h6 class="loading text-fixed-white">Calling...</h6>
              <div class="mt-5">
                <div class="row">
                  <div class="col-4">
                    <a
                      class="icon icon-shape rounded-circle mb-0"
                      href="javascript:void(0);"
                     
                      data-bs-target="#videomodal"
                    >
                      <i class="fas fa-video-slash"></i>
                    </a>
                  </div>
                  <div class="col-4">
                    <a
                      class="icon icon-shape rounded-circle text-fixed-white mb-0"
                      href="javascript:void(0);"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    >
                      <i class="fas fa-phone bg-danger text-fixed-white" (click)="modal.dismiss('Cross click')"></i>
                    </a>
                  </div>
                  <div class="col-4">
                    <a
                      class="icon icon-shape rounded-circle mb-0"
                      href="javascript:void(0);"
                    >
                      <i class="fas fa-microphone-slash"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <!-- modal-body -->
          </div>
        </div>
        <!-- modal-dialog -->
      </div>
    </ng-template>
    <!--End modal -->

    <!-- Audio Modal -->
    <ng-template #audiomodal let-modal>
      <div id="audiomodal" class="">
        <div class="modal-dialog m-0" role="document">
          <div class="modal-content border-0">
            <div class="modal-body mx-auto text-center p-5">
              <h6>Valex Voice call</h6>
              <img
                src="./assets/images/faces/6.jpg"
                class="rounded-circle user-img-circle h-8 w-8 mt-4 mb-3"
                alt="img"
              />
              <h5 class="mb-1 fw-medium">Daneil Scott</h5>
              <h6 class="loading">Calling...</h6>
              <div class="mt-5">
                <div class="row">
                  <div class="col-4">
                    <a
                      class="icon icon-shape rounded-circle mb-0"
                      href="javascript:void(0);"
                    >
                      <i class="fas fa-volume-up bg-light text-dark"></i>
                    </a>
                  </div>
                  <div class="col-4">
                    <a
                      class="icon icon-shape rounded-circle text-fixed-white mb-0"
                      href="javascript:void(0);"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    >
                      <i class="fas fa-phone text-fixed-white bg-success" (click)="modal.dismiss('Cross click')"></i>
                    </a>
                  </div>
                  <div class="col-4">
                    <a
                      class="icon icon-shape rounded-circle mb-0"
                      href="javascript:void(0);"
                    >
                      <i class="fas fa-microphone-slash bg-light text-dark"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <!-- modal-body -->
          </div>
        </div>
        <!-- modal-dialog -->
      </div>
    </ng-template>
    <!--End modal -->
  </div>
</div>
<!-- End::Off-canvas sidebar-->
